import { Injectable } from '@angular/core';
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { Observable } from "rxjs";
const month = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

@Injectable()
export class WidgetStatusPieBreakupService {
  apiUrl = environment.gateWayHost;
  editItem: any;
  constructor(public generic: GenericHttpService) {}

  getInTransitStatus(url, params): Observable<any> {
    const option = {
      method: "GET",
      //url: `${this.apiUrl}${url}`, // "./assets/data/p-d-reason.json", status-breakup-pie
      url: './assets/data/status-breakup-pie.json',
      query: params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processInTransitStatus)
    );
  }
  processInTransitStatus(data: any) {
    if (data.data.length === 0) return null;
    const total = data.data.reduce((sum, obj) => {
      return sum + obj.value;
    }, 0);
    const series = data.data.map(obj => [
      obj.status.charAt(0).toUpperCase() + obj.status.slice(1),
      Number(obj.quantity.toFixed(2))
    ]);
    
    return { series, total };
  }
  createChart(chartData, Options) {
    const chart = JSON.parse(JSON.stringify(HSET.chartData));
    chart.series[0].data = chartData.series;
    
    chart.title.text = `<div style = "text-align:center;">
    <strong style = "font-size:30px">${chartData.total}</strong>
    <br/>${Options.dataText}</div>`;

    // if (chartData.series.length > 1) {
    //   chart.title.text = `<div style = "text-align:center;">
    //   <strong style = "font-size:30px">${chartData.total}</strong>
    //   <br/>${Options.dataText}</div>`;
    // } else {
    //   chart.title.text = `<div style = "text-align:center;">
    //   <strong style = "font-size:30px">${chartData.series[0][1]}</strong>
    //   <br/>${Options.dataText}</div>`;
    // }

    return chart;
  }
}
